import "../Css/home.css";
import Headings from "../components/Headings";
import Image from "../components/Image";
import Skilldot from "../components/Skilldot";
import Study from "../components/Study";
import Skilldotnull from "../components/skilldotnull";
import { imges, navbar, study } from "../json/data";

export default function Resume() {
  return (
    <div className="Resume">
      {imges.slice(2, 3).map((pic, i) => {
        return <Image key={i} pictures={pic.img} />;
      })}{" "}
      <div className="Right-resume">
        {navbar.slice(1, 2).map((data, index) => {
          return (
            <Headings
              key={index}
              topDiscription={data.name}
              heading={data.heading}
            />
          );
        })}
        <div className="study">
          <div className="experience">
            <h3>Project Experience</h3>
            {study.slice(0, 4).map((study, i) => {
              return (
                <Study
                  key={i}
                  Cname={study.company}
                  yearTime={study.yearTime} 
                  para={study.para}
                  links= {study.links}
                />
              );
            })}
          </div>
          <div className="education">
            <h3>Education</h3>
            {study.slice(4, 6).map((study, i) => {
              return (
                <Study
                  key={i}
                  Cname={study.company}
                  yearTime={study.yearTime}
                  para={study.para}
                />
              );
            })}
          </div>
        </div>
        <div className="skills">
          <div className="skill-heading">
            <h2>MY SKILLS</h2>
          </div>
          <div className="skill-items">
            <div className="web-tech">
              <h4>Web Technologies</h4>
              <div className="web">
                <h6>HTML</h6>
                <div className="resultBox">
                  <Skilldot />
                  <Skilldot />
                  <Skilldot />
                  <Skilldot />
                  <Skilldotnull />
                </div>
              </div>
              <div className="web">
                <h6>CSS</h6>
                <div className="resultBox">
                  <Skilldot />
                  <Skilldot />
                  <Skilldot />
                  <Skilldot />
                  <Skilldotnull />
                </div>
              </div>
              <div className="web">
                <h6>JAVASCRIPT</h6>
                <div className="resultBox">
                  <Skilldot />
                  <Skilldot />
                  <Skilldot />
                  <Skilldotnull />
                  <Skilldotnull />
                </div>
              </div>
              <div className="web">
                <h6>REACT</h6>
                <div className="resultBox">
                  <Skilldot />
                  <Skilldot />
                  <Skilldot />
                  <Skilldotnull />
                  <Skilldotnull />
                </div>
              </div>
            </div>
            <div className="language-tech">
              <h4>Language</h4>
              <div className="lang">
                <h6>HINDI</h6>
                <div className="resultBox">
                  <Skilldot />
                  <Skilldot />
                  <Skilldot />
                  <Skilldot />
                  <Skilldotnull />
                </div>
              </div>
              <div className="lang">
                <h6>ENGLISH</h6>
                <div className="resultBox">
                  <Skilldot />
                  <Skilldot />
                  <Skilldot />
                  <Skilldotnull />
                  <Skilldotnull />
                </div>
              </div>
              <div className="lang">
                <h6>URDU</h6>
                <div className="resultBox">
                  <Skilldot />
                  <Skilldot />
                  <Skilldot />
                  <Skilldotnull />
                  <Skilldotnull />
                </div>
              </div>
              <div className="lang">
                <h6>OTHER</h6>
                <div className="resultBox">
                  <Skilldot />
                  <Skilldot />
                  <Skilldot />
                  <Skilldotnull />
                  <Skilldotnull />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
